import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment.local';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {GroupeResponse, GroupesResponse} from '../../models/groupes/Groupe';
import {GroupeBody} from '../../models/groupes/GroupeBody';
import {Params} from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class GroupesService {

  private apiUrl = `${environment.apiUrl}/groupes`;

  constructor(private http: HttpClient) { }

  getGroupes(params?: Params): Observable<GroupesResponse> {
    return this.http.get<GroupesResponse>(this.apiUrl, {params});
  }

  getGroupeById(id: number): Observable<GroupeResponse> {
    return this.http.get<GroupeResponse>(`${this.apiUrl}/${id}`);
  }

  postGroupe(groupe: GroupeBody): Observable<GroupeResponse> {
    return this.http.post<GroupeResponse>(this.apiUrl, groupe);
  }

  updateGroupe(id: number, groupe: GroupeBody): Observable<GroupeResponse> {
    return this.http.put<GroupeResponse>(`${this.apiUrl}/${id}`, groupe);
  }
}
